// import React, { useState } from "react";
// import { Form, Input, Button } from "antd";
// import axios from "axios";

// const ResetPassword = ({ email }) => {
//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [passwordHelperMessage, setPasswordHelperMessage] = useState("");
//   const [loading, setLoading] = useState(false);

//   const handlePasswordChange = (e) => {
//     setPassword(e.target.value);
//   };

//   const handleConfirmPasswordChange = (e) => {
//     setConfirmPassword(e.target.value);
//   };

//   const handleSubmit = async () => {
//     if (!password || !confirmPassword) {
//       setPasswordHelperMessage("Both fields are required");
//       return;
//     }

//     if (password !== confirmPassword) {
//       setPasswordHelperMessage("Passwords do not match");
//       return;
//     }

//     setLoading(true);
//     try {
//       await axios.post("/auth/reset-password", { email, password });
//       setLoading(false);
//       // Redirect to login page or show success message
//     } catch (error) {
//       setLoading(false);
//       setPasswordHelperMessage("Failed to reset password. Please try again.");
//     }
//   };

//   return (
//     <Form layout="vertical" onFinish={handleSubmit}>
//       <Form.Item help={<span style={{ color: "red" }}>{passwordHelperMessage}</span>}>
//         <Input.Password placeholder="Enter new password" value={password} onChange={handlePasswordChange} />
//       </Form.Item>
//       <Form.Item>
//         <Input.Password placeholder="Confirm new password" value={confirmPassword} onChange={handleConfirmPasswordChange} />
//       </Form.Item>
//       <Form.Item>
//         <Button type="primary" htmlType="submit" loading={loading}>
//           Reset Password
//         </Button>
//       </Form.Item>
//     </Form>
//   );
// };
// import React, { useState } from "react";
// import { Input, Button } from "antd";
// import "./ResetPassword.css"; // Custom styles for the component
// import logo from '../login/Logo.jpg'; // Import the logo
// import { useSelector } from "react-redux";
// import axios from 'axios';
// const  ResetPassword = () => {
//   const [code, setCode] = useState(new Array(6).fill(""));
//   const email = useSelector(state=>state.appStore.email)
//   console.log("email is",email)
//   const handleInputChange = (value, index) => {
//     if (/^[0-9]*$/.test(value)) {
//       const newCode = [...code];
//       newCode[index] = value;
//       setCode(newCode);

//       // Move to the next input if a digit is entered
//       if (value && index < 5) {
//         const nextInput = document.getElementById(`input-${index + 1}`);
//         if (nextInput) {
//           nextInput.focus();
//         }
//       }
//     }
//   };

//   const handleKeyPress = (e, index) => {
//     if (e.key === "Backspace" && !code[index] && index > 0) {
//       const prevInput = document.getElementById(`input-${index - 1}`);
//       if (prevInput) {
//         prevInput.focus();
//       }
//     }
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const verificationCode = code.join("");
//     console.log("Verification Code:", verificationCode);
//     try{
//       console.log('email sent',email)
//       axios.post('/auth/verify-otp', {
//         email:email,
//         otp:verificationCode
//       })
//       .then(function (response) {
//         console.log(response);
//         // navigate("/reset-password");
//       })
//       .catch(function (error) {
//         console.log(error);
//       });
      
//     }catch(e){
//       console.log('error',e)
//     }
//     // Perform the API call or verification logic here
//   };

//   return (
//     <div className="verification-card">
//       <div className="verification-container">
//         <img src={logo} alt="Surveyor's AI" className="verification-logo" />
//         <h2 className="verification-title">Sign in with verification code</h2>
//         <p className="verification-subtext">
//           We have sent a 6-digit code to ***@gmail.com
//         </p>
//         <div className="code-input-container">
//           {code.map((digit, index) => (
//             <Input
//               key={index}
//               id={`input-${index}`}
//               className="code-input"
//               maxLength={1}
//               value={digit}
//               onChange={(e) => handleInputChange(e.target.value, index)}
//               onKeyDown={(e) => handleKeyPress(e, index)}
//             />
//           ))}
//         </div>
//         <Button
//           type="primary"
//           className="verification-button"
//           onClick={(e)=>handleSubmit(e)}
//         >
//           Verify
//         </Button>
//       </div>
//     </div>
//   );
// };

// export default ResetPassword;

import React, { useState } from "react";
import { Input, Button } from "antd";
import "./ResetPassword.css";
import logo from '../login-module/Logo.png';
import { useSelector } from "react-redux";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { notification } from "antd";
const ResetPassword = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState(new Array(6).fill(""));
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const email = useSelector(state => state.user_slice.email);
  const showNotification = (type, message, description = '') => {
    notification[type]({
      message: message,
      description: description,
      placement: 'topRight',
      duration: 3.0, // Changed to 5 seconds
    });
  };
  const handleInputChange = (value, index) => {
    if (/^[0-9]*$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      setError(""); // Clear any previous error

      // Move to the next input if a digit is entered
      if (value && index < 5) {
        const nextInput = document.getElementById(`input-${index + 1}`);
        if (nextInput) {
          nextInput.focus();
        }
      }
    }
  };

  const handleKeyPress = (e, index) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      const prevInput = document.getElementById(`input-${index - 1}`);
      if (prevInput) {
        prevInput.focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const verificationCode = code.join("");
    
    if (verificationCode.length !== 6) {
      setError("Please enter all 6 digits of the verification code");
      return;
    }

    setIsLoading(true);
    setError("");

    try {
      const response = await axios.post('/auth/verify-otp', {
        email: email,
        otp: verificationCode
      });
      // Handle successful verification
      console.log(response);
      localStorage.setItem('resetToken', JSON.stringify(response.data.resetToken));
      showNotification('success', 'Success', 'Otp Verified');
        setTimeout(()=>{
            navigate("/Set-NewPassword");
        },2000)
      } catch (error) {
        console.log(error)
      if (error.response) {
        switch (error.response.status) {
          case 400:
            showNotification('error', 'Error', 'Invalid Otp');
            break;
          case 419:
            showNotification('error', 'Error', 'Otp expired or invalid');
            break;
          default:
            showNotification('error', 'Error', 'An error occurred. Please try again');
        }
      } else {
        showNotification('error', 'Network Error', 'Please check your connection');
      }
      // setError(errorMessage);
      setCode(new Array(6).fill("")); // Clear the code on error
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="verification-card">
      <div className="verification-container">
        <img src={logo} alt="Surveyor's AI" className="verification-logo" />
        <h2 className="verification-title">Sign in with verification code</h2>
        <p className="verification-subtext">
          We have sent a 6-digit code to {email ? `${email.substring(0, 3)}***@${email.split('@')[1]}` : '***@***.com'}
        </p>
        
        {error && (
          <div className="error-message" style={{ color: 'red', marginBottom: '10px' }}>
            {error}
          </div>
        )}

        <div className="code-input-container">
          {code.map((digit, index) => (
            <Input
              key={index}
              id={`input-${index}`}
              className="code-input"
              maxLength={1}
              value={digit}
              onChange={(e) => handleInputChange(e.target.value, index)}
              onKeyDown={(e) => handleKeyPress(e, index)}
              disabled={isLoading}
            />
          ))}
        </div>
        <Button
          type="primary"
          className="verification-button"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Verifying..." : "Verify"}
        </Button>
      </div>
    </div>
  );
};

export default ResetPassword;